// src/api/userService.js
// -----------------------------------------------------------------------------
// CRUD calls for User_TBL (Requirement #4: Admin can add new users to system).
// Field names in request/response bodies match the DTO Mapping column of
// Bug_Tracking_System_Schema.xlsx, e.g. userID, roleID, clientOrgID.
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';
import ENDPOINTS from './endpoints';

const userService = {
  /** Returns all users. Optionally pass query params for filtering/paging. */
  getAll: (params = {}) => axiosClient.get(ENDPOINTS.USERS, { params }),

  /** Returns a single user by userID. */
  getById: (userID) => axiosClient.get(ENDPOINTS.USER_BY_ID(userID)),

  create: (payload) => axiosClient.post(ENDPOINTS.AUTH_REGISTER, { id: 0, ...payload }),

  /** Updates an existing user by userID. */
  update: (userID, payload) => axiosClient.put(ENDPOINTS.USER_UPDATE, { ...payload, id: Number(userID) }),

  /** Deletes a user by userID. */
  remove: (userID) => axiosClient.delete(ENDPOINTS.USER_DELETE(userID)),

  /** Updates a user's role specifically. */
  updateRole: (userID, role) => axiosClient.put(ENDPOINTS.USER_UPDATE_ROLE, { userId: Number(userID), role }),

  /**
   * Deactivates / offboards a user (Additional Requirement: offboarding
   * workflow including reassignment of that user's open tickets).
   * payload: { reassignToUserID }
   */
  deactivate: (userID, payload) => axiosClient.post(ENDPOINTS.USER_DEACTIVATE(userID), payload),
};

export default userService;
